import { createElement } from 'rax';
import EmbedMinutePicker from '../embed-picker/minute-picker';
import BasePicker from './base-picker';
export default class MinutePicker extends BasePicker {
    renderPicker() {
        const { validRange } = this.props;
        return (<EmbedMinutePicker value={this.state.pickerValue} disabledDate={this.props.disabledDate} validRange={validRange} onChange={this.handleChange}/>);
    }
    get format() {
        return this.props.format;
    }
    getDefaultFormat() {
        return '';
    }
}
MinutePicker.defaultProps = {
    format: 'YYYY-MM-DD HH:mm',
};
